export const pathToScreenNameMap: Record<string, string> = {
  '/': 'home',
  '/machine-range/:id': 'range',
  '/machine/:id': 'machine',
  '/settings': 'settings',
};

export function getScreenNameFromPath(path: string): string | null {
  for (const route in pathToScreenNameMap) {
    const routePattern = new RegExp('^' + route.replace(/:\w+/g, '\\w+') + '$');
    if (routePattern.test(path)) {
      return pathToScreenNameMap[route];
    }
  }

  return null;
}

export interface BrowserInfo {
  devicePlatform: string;
  webBrowserName: string;
  webBrowserVersion: string;
}

const UNKNOWN_BROWSER_INFO: BrowserInfo = {
  devicePlatform: "Web",
  webBrowserName: 'Unknown',
  webBrowserVersion: 'Unknown'
};

const BROWSER_PATTERNS: Array<{ name: BrowserInfo['webBrowserName']; pattern: RegExp }> = [
  { name: 'Edge', pattern: /Edg\/([\d.]+)/ },
  { name: 'Opera', pattern: /(?:OPR|Opera)\/([\d.]+)/ },
  { name: 'Chrome', pattern: /Chrome\/([\d.]+)/ },
  { name: 'Firefox', pattern: /Firefox\/([\d.]+)/ },
  { name: 'Safari', pattern: /Version\/([\d.]+).*Safari/ },
];

export function getBrowserInfo(): BrowserInfo {
  if (typeof navigator === 'undefined') {
    return UNKNOWN_BROWSER_INFO;
  }

  const userAgent = navigator.userAgent;

  for (const { name, pattern } of BROWSER_PATTERNS) {
    const match = userAgent.match(pattern);

    if (match) {
      return {
        devicePlatform: "Web",
        webBrowserName: name,
        webBrowserVersion: match[1] ?? 'Unknown'
      };
    }
  }

  return UNKNOWN_BROWSER_INFO;
}
